import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TextTypo from "../helpers/TextTypo";
import { useDispatch, useSelector } from "react-redux";
import {
  myLoanAction,
  downloadDocumentAction,
  downloadAction,
  zipDownloadAction,
  downloadApplicantDocumentAction,
  downloadApplicantZipDocumentAction,
} from "../../redux/actions/applicationAction";
import CardPaper from "../helpers/CardPaper";
import { decodeToken, getStatusColor, getUserNames } from "utils";
import { Tag, Timeline } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { HouseOutlined, VerifiedUser } from "@material-ui/icons";
import CommentForm from "components/Comment";
import Button from "components/Button";

const MyApplication = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { zipDoc, myLoan } = useSelector(({ myLoan, applicationDocs }) => ({
    myLoan: myLoan?.data,
    myLoanLoading: myLoan?.loading,
    zipDoc: applicationDocs?.applicantZipDocument
  }));

  const [isDownloadCompleted, setIsDownloadCompleted] = useState(false);
  const [isZipDownloadCompleted, setIsZipDownloadCompleted] = useState(false);
  const [showComments, setShowComments] = useState(true);

  useEffect(() => {
    dispatch(myLoanAction());
  }, []);

  useEffect(() => {
    if(zipDoc?.status === "success"){

    }
  }, [zipDoc]);

  const getStatusData = (status) => {
    switch (status) {
      case "Pending":
        return {
          icon: <ClockCircleOutlined />,
          description: "The application is under review",
          color: "#FAAD14",
        };
      case "Approved":
        return {
          icon: <CheckCircleOutlined />,
          description: "The application has been approved",
          color: "##00D83C",
        };
      case "Rejected":
        return {
          icon: <CloseCircleOutlined />,
          description: "Unfortunately, the application has been rejected",
          color: "#FF4D4F",
        };
      default:
        return {
          icon: <ExclamationCircleOutlined />,
          description: "The status is unknown.",
        };
    }
  };

  const getUPIlocation = (objString) => {
    const obj = JSON.parse(objString);
    const {
      cell: { cellName },
      sector: { sectorName },
      district: { districtName },
      province: { provinceName },
    } = obj || {};
    return `${provinceName} , ${districtName}, ${sectorName}, ${cellName}`;
  };



  const handleZipDownload = () => {
    dispatch(downloadApplicantZipDocumentAction());
    setIsZipDownloadCompleted(true);
    setIsDownloadCompleted(false);
  };

  const handleDownload = (docId) => {
    dispatch(downloadApplicantDocumentAction(docId));
  };
  return (
    <div style={{ marginTop: 20 }}>
      <Container>
        <TextTypo
          text={`Welcome back, ${getUserNames()?.split(" ")[1]}`}
          variant="h5"
        />

        <Grid container spacing={2} className="mt-4">
          <Grid item xs={12} sm={12} md={showComments ? 7 : 10}>
            {/* <Timeline mode="left">
              <Timeline.Item
                color={getStatusData(myLoan?.bankStatus).color}
                dot={getStatusData(myLoan?.bankStatus).icon}
                label={moment(myLoan?.createdAt).format("DD-MM-YYYY")}
              >
               {getStatusData(myLoan?.backEndStatus).description}
              </Timeline.Item>
              <Timeline.Item
                color="#056333"
                dot={<HouseOutlined />}
                label={moment(myLoan?.createdAt).format("DD-MM-YYYY")}
              >
                Applied for house loan
              </Timeline.Item>
              <Timeline.Item
                color="#056333"
                dot={<VerifiedUser />}
                label={moment(decodeToken()?.createdAt).format("DD-MM-YYYY")}
              >
                Created Giriwawe account
              </Timeline.Item>
            </Timeline> */}
            <div className="d-flex justify-content-between py-3">
              <div>
                <div className="d-flex">
                  <label style={{ fontWeight: "bold" }}>
                    RHA Status: &nbsp;
                  </label>
                  <label>
                    {" "}
                    <Tag color={getStatusColor(myLoan?.backEndStatus)}>
                      {myLoan?.backEndStatus}
                    </Tag>
                  </label>
                </div>
              </div>
              <div className=" mx-5">
                <div className="d-flex">
                  <label style={{ fontWeight: "bold" }}>
                    Bank Status: &nbsp;
                  </label>
                  <label>
                    <Tag color={getStatusColor(myLoan?.bankStatus)}>
                      {myLoan?.bankStatus}
                    </Tag>
                  </label>
                </div>
              </div>
            </div>
            <div className="card p-3 my-2">
              <h5>{t("personal-info")}</h5>
              <hr />
              <div className="d-flex justify-content-between flex-wrap">
                <div>
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>{t("names")}</label>
                    <label>
                      {myLoan?.applicant?.firstName +
                        " " +
                        myLoan?.applicant?.lastName}
                    </label>
                  </div>
                  <div className="d-flex flex-column mt-3">
                    <label style={{ fontWeight: "bold" }}>
                      {t("id-number")}
                    </label>
                    <label>{myLoan?.applicant?.nationalId}</label>
                  </div>
                </div>
                <div>
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>{t("dob")}</label>
                    <label>{myLoan?.applicant?.dob}</label>
                  </div>
                  <div className="d-flex flex-column mt-3">
                    <label style={{ fontWeight: "bold" }}>{t("gender")}</label>
                    <label>{myLoan?.applicant?.gender}</label>
                  </div>
                </div>
                <div>
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>
                      {t("marital-status")}
                    </label>
                    <label>{myLoan?.applicant?.maritalStatus}</label>
                  </div>
                  <div className="d-flex flex-column mt-3">
                    <label style={{ fontWeight: "bold" }}>{t("phone")}</label>
                    <label>{myLoan?.applicant?.phone}</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-3 my-2">
              <h5>{t("loan-details")}</h5>
              <hr />
              <div className="d-flex justify-content-between py-3">
                <div>
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>
                      {t("Household-income")}
                    </label>
                    <label>RWF {myLoan?.rraCombinedHouseHoldIncome}</label>
                  </div>
                  <div className="d-flex flex-column mt-3">
                    <label style={{ fontWeight: "bold" }}>
                      {t("deductable-income")}
                    </label>
                    <label>
                      RWF {myLoan?.deductableIncome?.toLocaleString()}
                    </label>
                  </div>
                </div>

                <div className="mx-5">
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>{t("property-value")}</label>
                    <label>
                      RWF {myLoan?.propertyValueLimit?.toLocaleString()}
                    </label>
                  </div>
                  <div className="d-flex flex-column mt-3">
                    <label style={{ fontWeight: "bold" }}>{t("present-value")}</label>
                    <label>RWF {myLoan?.presentValue?.toLocaleString()}</label>
                  </div>
                </div>

                <div className="mx-5">
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>
                      {t("loan-provider")} (1)
                    </label>
                    <label> {myLoan?.bankProvider1?.name}</label>
                  </div>
                  <div className="d-flex flex-column mt-3">
                    <label style={{ fontWeight: "bold" }}>
                    {t("loan-provider")} (2)
                    </label>
                    <label>{myLoan?.bankProvider2?.name || "None"}</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="card p-3 my-2">
              <h5>{t("employment-info")}</h5>
              <hr />
              <div className="d-flex justify-content-between">
                <div>
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>
                      {" "}
                      {t("employer")}
                    </label>
                    <label>{myLoan?.applicant?.employerName || "N/A"}</label>
                  </div>
                  <div className="d-flex flex-column mt-2">
                    <label style={{ fontWeight: "bold" }}>
                      {" "}
                      {t("employer")} (RRA)
                    </label>
                    <label>{myLoan?.applicant?.rraEmployerName || "N/A"}</label>
                  </div>
                </div>
                <div>
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>
                      {t("profession")}
                    </label>
                    <label>{myLoan?.applicant?.profession || "N/A"}</label>
                  </div>
                  <div className="d-flex flex-column mt-2">
                    <label style={{ fontWeight: "bold" }}>
                      {" "}
                      {t("Gross Income")} (RRA)
                    </label>
                    <label>
                      {"RWF " +
                        myLoan?.applicant?.rraGrossIncome?.toLocaleString() ||
                        "N/A"}
                    </label>
                  </div>
                </div>
                <div>
                  <div className="d-flex flex-column">
                    <label style={{ fontWeight: "bold" }}>{t("Salary")}</label>
                    <label>
                      RWF {myLoan?.applicant?.salarynet.toLocaleString()}
                    </label>
                  </div>
                  <div className="d-flex flex-column mt-2">
                    <label style={{ fontWeight: "bold" }}>
                      {" "}
                      {t("Combined Income")} (RRA)
                    </label>
                    <label>
                      {"RWF " +
                        myLoan?.rraCombinedHouseHoldIncome?.toLocaleString() ||
                        "N/A"}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="card p-3 my-2">
              <h5>UPI Info</h5>
              <hr />
              {myLoan?.applicant?.upis?.length > 0 ? (
                myLoan?.applicant?.upis?.map((u, key) => (
                  <>
                    <div
                      className="d-flex justify-content-between my-2"
                      key={key}
                    >
                      <div>
                        <div className="d-flex flex-column">
                          <label style={{ fontWeight: "bold" }}>
                            {t("upi")}
                          </label>
                          <label>{u.upi}</label>
                        </div>
                        <div className="d-flex flex-column mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            {t("land-usage")}
                          </label>
                          <label>{u.landUseNameEnglish}</label>
                        </div>
                      </div>
                      <div>
                        <div className="d-flex flex-column">
                          <label style={{ fontWeight: "bold" }}>
                            {t("primary-owner")}
                          </label>
                          <label>{u.primaryOwner}</label>
                        </div>
                        <div className="d-flex flex-column mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            {t("under-mortgage")}
                          </label>
                          <label>{u.isUnderMortgage ? "Yes" : "No"}</label>
                        </div>
                      </div>
                      <div>
                        <div className="d-flex flex-column">
                          <label style={{ fontWeight: "bold" }}>
                            {t("is-developed")}
                          </label>
                          <label>{u.isDeveloped === null ? "No" : "Yes"}</label>
                        </div>
                        <div className="d-flex flex-column mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            {t("parcel-location")}
                          </label>
                          <label>{getUPIlocation(u.parcelLocation)}</label>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </>
                ))
              ) : (
                <label className="text-muted px-2">No UPI Info</label>
              )}
            </div>

            <hr />
            <div className="card p-3 my-2">
              <h5>{t("spouse-details")}</h5>
              <hr />

              {myLoan?.applicant?.spouse ? (
                <div className="d-flex justify-content-between">
                  <div>
                    <div className="d-flex flex-column">
                      <label style={{ fontWeight: "bold" }}>{t("names")}</label>
                      <label>
                        {myLoan?.applicant?.spouse?.firstName +
                          " " +
                          myLoan?.applicant?.spouse?.lastName}
                      </label>
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <label style={{ fontWeight: "bold" }}>{t("id-number")}</label>
                      <label>{myLoan?.applicant?.spouse?.nationalId}</label>
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <label style={{ fontWeight: "bold" }}>{t("phone")}</label>
                      <label>
                        {myLoan?.applicant?.spouse?.phone || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div>
                    <div className="d-flex flex-column">
                      <label style={{ fontWeight: "bold" }}>{t("employer")}</label>
                      <label>
                        {myLoan?.applicant?.spouse?.employerName || "N/A"}
                      </label>
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <label style={{ fontWeight: "bold" }}>{t("employer")}(RRA)</label>
                      <label>
                        {myLoan?.applicant?.spouse?.rraEmployerName || "N/A"}
                      </label>
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <label style={{ fontWeight: "bold" }}>{t("profession")}</label>
                      <label>
                        {myLoan?.applicant?.spouse?.profession || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div>
                    <div className="d-flex flex-column">
                      <label style={{ fontWeight: "bold" }}>{t('income')} - Net</label>
                      <label>
                        {myLoan?.applicant?.spouse?.salarynet?.toLocaleString()}
                      </label>
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <label style={{ fontWeight: "bold" }}>
                      {t('income')} - RRA Gross
                      </label>
                      <label>
                        {
                          myLoan?.applicant?.spouse?.rraGrossIncome?.toLocaleString() ||
                          "N/A"}
                      </label>
                    </div>
                  </div>
                </div>
              ) : (
                <label className="text-muted px-2">No Spouse Info</label>
              )}
            </div>

            <div className="card p-3 my-2">
              <h5>Attachments</h5>
              <hr />
              <div className="d-flex">
                <div>
                  <div className="d-flex flex-column">
                    <label
                      className={`btn btn-link`}
                      style={{ fontWeight: "bold" }}
                      onClick={handleZipDownload}
                    >
                      {" "}
                      {t("zip-download")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={showComments ? 4 : 2} className="mt-5">
            <label
              onClick={() => setShowComments(!showComments)}
              className="btn btn-link"
            >
              {showComments ? "Hide" : "Show"} Comments
            </label>
            {showComments && (
              <CommentForm
                applicationComments={myLoan?.documents?.sort(
                  (a, b) => b.id - a.id
                )}
                handleDownload={handleDownload}
                showEditor={true}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default MyApplication;
